// 1、店铺自动绑定 2、webhook绑定异常 3、商品导入完成 4、EDM邮件发送完成 5、邮件超时
// 6、店铺同步完成 7、商品专辑同步完成 8、邮箱账号异常 9、FaceBook账号异常 10、Google账号异常
// 11、店铺过期 12、认证信息变更 13、未授权店铺商品读写权限
export function routerTo(item) {
  switch (item.type) {
    case 1:
    case 2:
      this.$router.push('/store')
      break
    case 3:
      this.$router.push('/message-center')
      break
    case 4:
      this.$router.push('/customers/notice')
      break
    case 5:
      this.$router.push({ path: '/in-box' })
      break
    case 6:
      this.$router.push({ path: '/stores/sync-log', query: { type: 1, shopId: item.shopId } })
      break
    case 7:
      this.$router.push({ path: '/stores/sync-log', query: { type: 2, shopId: item.shopId } })
      break
    case 8:
      this.$router.push({ path: '/stores/shop-site', query: { type: 1 } })
      break
    case 9:
      this.$router.push({ path: '/stores/shop-site', query: { type: 2 } })
      break
    case 10:
      this.$router.push({ path: '/stores/shop-site', query: { type: 3 } })
      break
    case 11:
    case 12:
    case 13:
      this.$router.push(`/stores/detail/${item.shopId}`)
      break
    default:
      break
  }
}
